import { Text, Field, withDatasourceCheck } from '@sitecore-jss/sitecore-jss-nextjs';
import { ComponentProps } from 'lib/component-props';

type MinistryDetailsProps = ComponentProps & {
  fields: {
    heading: Field<string>;
  };
};

const MinistryDetails = (props: MinistryDetailsProps): JSX.Element => (
  <section aria-label="Ministry details">
    <p>MinistryDetails Component</p>
    <Text field={props.fields.heading} />
  </section>
);

export default withDatasourceCheck()<MinistryDetailsProps>(MinistryDetails);
